// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--VKOxD";
export var detailsmasthead = "project-details-module--detailsmasthead--akpiC";
export var featured = "project-details-module--featured--t+R-7";
export var html = "project-details-module--html--VoAwY";